/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Original_Text_Preview_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Original text preview" |
*
* @param {Event_Original_Text_Preview_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_original_text_preview_aria_label = /** @type {((inputs?: Event_Original_Text_Preview_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Original_Text_Preview_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Apercu du texte original")
	if (locale === "de") return /** @type {LocalizedString} */ ("Originaltextvorschau")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anteprima del testo originale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительный просмотр исходного текста")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista previa del texto original")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("原文预览")
	if (locale === "ja") return /** @type {LocalizedString} */ ("元のテキストのプレビュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मूल पाठ पूर्वावलोकन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pré-visualização do texto original")
	return /** @type {LocalizedString} */ ("Original text preview")
});